<template>
  <div class="footBox">
    <div class="fbody">
      <el-row :gutter="20" >
        <el-col :lg="8" :xs="24">
          <div class="footTitleText">Our Mission</div>
          <div class="fbodyItem">
            <div> 
              From a Single Resistor to a Global Electronics Supply Chain!
            </div>
            <div>
              We are committed to building a professional electronic trading and procurement platform. 
            </div>
            <div>
              Let our trust begin with a single resistor! 
            </div>
          </div>
        </el-col>
        <el-col :lg="5" :xs="24">
          <div class="footTitleText">COMPANY</div>
          <div class="fbodyItem">
            <div v-for="item in company" :key="item.name" @click="goTo(item)">{{ item.name }}</div>
            <!-- <div>Why Choose JH</div>
            <div>Terms&Conditions</div>
            <div>Privacy Policy</div>
            <div>Contact Us</div>
            <div>Sitemap</div>
            <div>FAQ</div> -->
          </div>
        </el-col>
        <el-col :lg="6" :xs="24">
          <div class="footTitleText">HELP CENTER</div>
          <div class="fbodyItem">
            <div v-for="item in helpCenter" :key="item.name" @click="goTo(item)">{{ item.name }}</div>
            <!-- <div>Payment</div>
            <div>Shipping</div>
            <div>Import from JH</div>
            <div>B2B</div>
            <div>Drop Shipping</div>
            <div>Discount Policy</div> -->
          </div>
        </el-col>
        <el-col :lg="5" :xs="24">
          <div class="footTitleText">Opening hours</div>
          <div class="fbodyItem">
            <div> 
              Mon-Fri|9am-8pm (GMT+8)
            </div>
            <div>
              Sat|9am-9pm (GMT+8)
            </div>
            <div>
              Sun|9am-9pm (GMT+8)
            </div>
          </div>
        </el-col>
        <!-- <el-col :lg="6" :xs="24">
          <div class="footTitleText">COOPERATION</div>
          <div class="fbodyItem">
            <div>Hot-sell Stock</div>
            <div>Sourcing Products</div>
            <div>Agent Service</div>
            <div>Logistic&Warehouse</div>
            <div>Value-added Services</div>
            <div>After-sale Service</div>
            <div>Blog</div>
          </div>
        </el-col> -->
        <!-- <el-col :lg="5" :xs="24">
          <div class="footTitleText">NEWSLETTER</div>
          <div>Get exciting promos and offers, product updates and much more!</div>
          <div class="newBox">
            <el-input style="width: 200px;"   v-model="userName" placeholder="Enter your email address"></el-input>
            <div class="subBtn" >SUBMIT</div>
          </div>
        </el-col> -->
      </el-row>
    </div>
    <!-- <div class="fBottom">
      <div>
        <div>JH Global Trading (HK) Co., Limited</div>
        <div>Certificate No. 67605146-000-04-22-7</div>
        <div>成都市买买买商务有限公司</div>
        <div>统一社会信用代码:621648854D325GSA</div>
      </div>
      <div>
        <img class="payImg" src="@/assets/img/footPay.png" alt="">
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: '',
      company: [
        {
          name: 'About Us',
          path: 'aboutUs'
        },
        {
          name: 'Contact Us',
          path: 'contact'
        },
        // {
        //   name: 'Shipping & Policies',
        //   path: 'shipping'
        // },
        {
          name: 'Privacy Policy',
          path: 'privacy'
        },
        {
          name: 'Terms&Conditions',
          path: 'terms'
        },
        {
          name: 'Blog',
          path: 'blog'
        },

      ],
      helpCenter: [
        {
          name: 'How to Order',
          path: 'helpCenter',
          id:1,
        },
        {
          name: 'How to pay',
          path: 'helpCenter',
          id:2,
        },
        {
          name: 'After-sales service',
          path: 'helpCenter',
          id:3,
        },
        {
          name: 'One-stop service',
          path: 'helpCenter',
          id:4,
        },
        {
          name: 'Shipping & Policies',
          path: 'shipping',
          id:5,
        },

      ],
    }
  },
  methods: {
    goTo(item) {
      if (item.id) {
        this.$router.push(
          {
            path: item.path,
            query: {
              type: item.id,
            },

          }
        );
        return
      }
      this.$router.push(item.path);
      // const route = this.$router.resolve({ path: item.path });
      // window.open(route.href, '_blank');
    },
  }

}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .footBox{
    padding:10px 10px 100px 10px !important;
  }
}
.footBox{
  padding:0 100px 100px 100px;
  background: #fbf7ec;
  color: #938f88;
  .fbody{
    margin-top: 10px;
    padding: 0 10px 30px 10px;
    color: #6E6E6E;
    font-size: 14px;
    border-bottom: 1px solid #ccc;
    .footTitleText{
      font-size: 30px;
      margin-top: 20px;
      margin-bottom: 10px;
    }
    .footTitleText::after{
      content: '';
      display: block;
      width: 20px;
      height: 3px;
      background: #6E6E6E;
      margin-top: 5px;
    }
    .fbodyItem{
      >div{
        line-height: 25px;
        cursor: pointer;
        margin-bottom: 5px;
      }
      >div:hover{
        color: #f4b011;
        // transform: scale(1.03);
        // transition: all .3s;
      }

    }
    .fbodyItem:nth-child(1){
        cursor: default;
      }
    img{
      margin-top: 10px;
      height: 42px;
    }
    .newBox{
      margin: 10px 0;
      .subBtn{
        margin-top: 10px;
        width: 120px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 5px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        text-align: center;
        background: #47ABE7;
      }
    }
  }
  .fBottom{
    display: flex;
    align-items: end;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px;
    font-size: 13px;
    color: #6E6E6E;
    >div:nth-child(1){
      margin-bottom: 10px;
      >div{
        margin-top: 3px;
      }
    }
    .payImg{
      width: 100%;
    }
  }
}
</style>